export default __webpack_public_path__ + "images/RH.21307c5.png";